// extracted by mini-css-extract-plugin
export var hideEditor = "_ie-2";
export var infoIcon = "_ie-3";
export var label = "_ie-1";
export var labelContainer = "_ie-0";
export var readonlyText = "_ie-4";